export const stateValidator = validator => (validator === true ? false : null);

export default {
  install(Vue) {
    Vue.prototype.$bsStateValidator = stateValidator;
  },
};
